import { useTranslation } from 'react-i18next';
import { Loading, Stack, styled, Text } from 'shell/components';

const FeedbackItemRegenerating = (props) => {
    const { t } = useTranslation('assignment');

    return (
        <RootStack {...props} alignItems={'center'} justifyContent={'center'} spacing={2}>
            <SpinnerContainer>
                <Loading />
            </SpinnerContainer>
            <Text align={'center'} color={'light'} variant={'p3'}>
                {t(
                    'grading-section.feedback-regenerating-item',
                    'This feedback is regenerating. You can continue grading.'
                )}
            </Text>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => ({
    minHeight: '96px',
    padding: theme.spacing(3),
}));

const SpinnerContainer = styled(Stack)(() => ({
    position: 'relative',
    width: '28px',
    height: '28px',
}));

export default FeedbackItemRegenerating;
